import type { AtbCatalogRow, SensitivityColumnMeta, SensitivityPivotModel } from './sensitivity-atb-pivot';
import { lookupCell } from './sensitivity-atb-pivot';

/**
 * Escape campo CSV europeo (`;` separador): comillas RFC4180 donde haga falta.
 */
export function escapeCsvField(value: string): string {
  const s = value == null ? '' : String(value);
  const needsQuotes = /[;"'\n\r]/.test(s);
  if (!needsQuotes) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function formatCsvDate(d: unknown): string {
  if (d == null || d === '') return '';
  if (d instanceof Date) {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return String(d);
}

function columnTitle(col: SensitivityColumnMeta): string {
  const dateStr = formatCsvDate(col.entryDate);
  const parts = [col.requisNr, dateStr, col.isolate, col.materialName].filter((x) => x !== '');
  return parts.join(' ');
}

/** Construye CSV pivotado (primer columna nombre ATB, demás columnas visibles del antibiograma). */
export function buildSensitivityAtbCsv(
  model: SensitivityPivotModel,
  visibleCatalogRows: readonly AtbCatalogRow[],
  visibleColumns: readonly SensitivityColumnMeta[]
): string {
  const delim = ';';
  const header0 = '';
  const headerTitles = visibleColumns.map((c) => escapeCsvField(columnTitle(c)));
  const lines: string[] = [[escapeCsvField(header0), ...headerTitles].join(delim)];

  for (const atb of visibleCatalogRows) {
    const rowCells = visibleColumns.map((col) => {
      const cell = lookupCell(model, col.requisCol, atb.testRow);
      return escapeCsvField(cell.result ?? '');
    });
    lines.push([escapeCsvField(atb.atbName), ...rowCells].join(delim));
  }

  return lines.join('\r\n');
}
